import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { getAuthAdapter } from '../auth/createAuthAdapter';

/**
 * Bridges native SAML deep-link callbacks into the app router. On iOS the SAML
 * redirect arrives as an `appUrlOpen` event (custom URL scheme) rather than an
 * HTTP navigation, so this side-effect component forwards the callback query to
 * the shared `/auth/callback` route — the same page web reaches via the backend's
 * HTTP redirect. AuthCallbackPage then performs the code exchange or renders the
 * error, so both platforms share one callback handler.
 *
 * Must be mounted inside the Router (it navigates). Inert on web, where
 * `onDeepLinkAuth` is a noop — the browser handles the redirect directly.
 */
export function DeepLinkAuthHandler(): null {
  const navigate = useNavigate();

  useEffect(() => {
    const unsubscribe = getAuthAdapter().onDeepLinkAuth((search) => {
      // replace: true so the transient callback URL doesn't linger in history
      // (mirrors AuthCallbackPage's own post-exchange navigation).
      navigate({ pathname: '/auth/callback', search }, { replace: true });
    });
    return unsubscribe;
  }, [navigate]);

  return null;
}
